import { render, staticRenderFns } from "./BusIcon.vue?vue&type=template&id=1d6fd495&scoped=true"
import script from "./BusIcon.vue?vue&type=script&lang=js"
export * from "./BusIcon.vue?vue&type=script&lang=js"
import style0 from "./BusIcon.vue?vue&type=style&index=0&id=1d6fd495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fd495",
  null
  
)

export default component.exports